// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"da1020d1","527":"7d733afd"}[chunkId] + ".chunk.js";
};